import React, { useState, useEffect } from 'react';
import bg2 from '../assets/images/dining_7.jpg';

const images = bg2

const DiningHero = ({ language }) => {
  return (
    <section
      className="d-flex align-items-center text-white text-center"
      style={{
        backgroundImage: `url(${images})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '60vh',
        transition: 'background-image 1s ease-in-out',
        position: 'relative'
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1 className="display-3 fw-bold mb-3">
              {language === 'am' ? 'ብሉ ኔስት ሆቴል ሬስቶራንት' : 'Blue Nest Hotel Restaurant'}
            </h1>
            <p className="lead">
              {language === 'am' 
                ? 'ባህላዊ እና ዓለም አቀፍ ምግቦች በጥራት እና በአዲስ ሁኔታ' 
                : 'Traditional and international cuisine with quality and freshness'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiningHero;
